const customizationSettings =
  typeof window === 'undefined' ? undefined : window.CASHIER_CONFIG?.customization_settings;

const readBoolean = (value: boolean | undefined): boolean | null =>
  typeof value === 'boolean' ? value : null;

export const embeddedShowBackButton = readBoolean(customizationSettings?.show_back_button);

export const embeddedShowCloseButton = readBoolean(customizationSettings?.show_close_button);

export const embeddedHeaderStyle = customizationSettings?.header_style ?? null;

export const embeddedLayout = customizationSettings?.layout ?? null;

export const embeddedAppearance = customizationSettings?.appearance ?? null;
